class LoginCtrl  
  @$inject: ["$rootScope", "$scope", "$q", "$state", "toasty", "User"]  
  constructor: ($rootScope, $scope, $q, $state, toasty, User)->
    $scope.user = new User()    
    $scope.login = ()->
      $scope.user.$login().then ()->
        $state.go("devices")
      .catch (err)->
        toasty.warning
          title: 'Login Fail'
          msg: 'Please check your username and password'



module.exports = LoginCtrl




// WEBPACK FOOTER //
// ./src/component/login/controller.coffee